

// components/HomeBanner.jsx
import { useEffect, useState } from "react";

const Banner = ({ fetchData, lang }) => {
    const [content, setContent] = useState(null);
    const [fallbackContent, setFallbackContent] = useState(null);

    useEffect(() => {
        // Fetch current language
        fetchData(lang).then(setContent);

        // Fetch English fallback if not EN
        if (lang !== "en") {
            fetchData("en").then(setFallbackContent);
        }
    }, [lang]);

    // Helper: get value with fallback
    const getValue = (main, fallback) => main || fallback || "No content";

    // Helper: get image with fallback
    const getImage = (main, fallback) => main || fallback;

    // Helper: build URL safely
    const getImageUrl = (img) => {
        if (!img) return "/fallback.jpg";
        return (
            process.env.REACT_APP_Base_URL +
            (img?.formats?.url || img?.url || "")
        );
    };

    if (!content && !fallbackContent) return <p className="p-6">Loading...</p>;

    const mainImg = getImage(
        content?.Banner_Image,
        fallbackContent?.Banner_Image
    );

    return (
        <section>
            <div className="h-[100dvh] overflow-hidden relative">
                <img 
                    className="banner-img"
                    src={getImageUrl(mainImg)}
                    alt={mainImg?.name || "Banner Main"}
                />
                <div className="banner-text-wrapper padding-x-40">
                    <div className="section-name-wrapper">
                        <span 
                            style={{ 
                                height: "10px", 
                                display: "block", 
                                width: "10px", 
                                backgroundColor: "#fff", 
                                borderRadius: "100%", 
                                marginRight: "10px" 
                            }}
                        ></span>
                        <span className="section-name" style={{ color: "#fff" }}>
                            {getValue(
                                content?.Section_Name,
                                fallbackContent?.Section_Name
                            )}
                        </span>
                    </div>

                    {/* Text */}
                    <h1 className="pt-2.5 banner-heading" style={{ opacity: 1 }}>
                        {getValue(
                            content?.Banner_Heading,
                            fallbackContent?.Banner_Heading
                        )}
                    </h1>
                </div>
            </div>
        </section>
    );
};

export default Banner;